import React from 'react';

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;

type AiActivityPreviewHeaderProps = {
  iconComponent: SvgComponent,
  header: string;
  className?: string;
};

/**
 * Shared header component used across multiple AI activity generation and preview flows.
 *
 * Renders a provided SVG icon and header text centered in a vertical layout. This is
 * intended for reuse by AI-related activity builders/previews to keep header styling
 * consistent across the NovoEd AI experience.
 *
 * @param iconComponent SVG icon component to render above the header text.
 * @param header        Text label/title displayed under the icon.
 * @param className     Optional additional class names to customize layout or styling.
 */
const AiActivityPreviewHeader = (props: AiActivityPreviewHeaderProps) => {
  const { iconComponent: IconComponent, header, className = '' } = props;

  return (
    <div className={`d-flex flex-column align-items-center ${className}`}>
      <IconComponent
        height={30}
        width={60}
        aria-label={header}
        role='img'
      />
      <p className='page-title text-gray-2 mt-2 mb-0'>
        {header}
      </p>
    </div>
  );
};

export default AiActivityPreviewHeader;
